import * as React from "react";
import Link from "gatsby-link";
import {StatuteBlockWrapper,StatuteSectionHeader,StatuteBlock} from "./statute-elements";
import * as companyData from "../../constants/company-data";
import * as staticUrls from "../../constants/static-urls";

interface CookieStatuteBlockProps {}

const CookieStatuteBlock = (props: CookieStatuteBlockProps) => {
  return (
    <div className="materialize-theme-styles">
      <StatuteBlockWrapper>

        <StatuteBlock>
          <p style={{textAlign: "center"}}>
            <em>Serwisu Fakturomania (fakturomania.pl, app.fakturomania.pl, pomoc.fakturomania.pl)</em>
          </p>
          <p style={{textAlign: "center"}}>
            Obowiązuje od dnia 9 października 2026 r.
          </p>
        </StatuteBlock>

        <StatuteSectionHeader ordinal={1} sectionName="Postanowienia ogólne"/>
        <StatuteBlock>
          <ol>
            <li>
              Polityka cookies określa zasady przechowywania informacji i uzyskiwania dostępu do informacji przechowywanych w urządzeniach końcowych
              osób korzystających z Serwisu, w szczególności za pomocą plików cookies i podobnych technologii, a także zasady przetwarzania danych
              osobowych zbieranych w ten sposób.
            </li>
            <li>
              Serwis obejmuje stronę internetową dostępną pod adresem fakturomania.pl, aplikację dostępną pod adresem app.fakturomania.pl
              oraz centrum pomocy dostępne pod adresem pomoc.fakturomania.pl.
            </li>
            <li>
              Administratorem danych osobowych zbieranych za pomocą cookies jest Fakturomania sp. z o.o. z siedzibą w Grodzisku Mazowieckim,
              ul. Gen. L. Okulickiego 19B lok. 11, 05-825 Grodzisk Mazowiecki, wpisana do rejestru przedsiębiorców Krajowego Rejestru Sądowego
              {/* adres e-mail wg decyzji przy wdrożeniu FAK-28914 (w dokumencie był placeholder na osobny adres w sprawach danych osobowych) */}
              pod numerem KRS 0000495029, NIP 5291802680, REGON 147060749 (dalej: „<strong>Administrator</strong>”).
              Z Administratorem można kontaktować się, również w sprawach dotyczących danych osobowych, pod adresem
              e-mail <a href={`mailto:${companyData.FAKTUROMANIA_APP_COMPANY_EMAIL}`}>{companyData.FAKTUROMANIA_APP_COMPANY_EMAIL}</a>.
            </li>
            <li>
              Dostawcy narzędzi zewnętrznych wskazanych w § 4 i § 5 mogą przetwarzać dane zebrane za pomocą cookies także jako odrębni
              administratorzy, na zasadach określonych w ich politykach prywatności.
            </li>
            <li>
              Ilekroć w Polityce cookies jest mowa o Użytkowniku, należy przez to rozumieć każdą osobę korzystającą z Serwisu, również
              nieposiadającą Konta. Pozostałe pojęcia pisane wielką literą mają znaczenie nadane im
              w <Link to={staticUrls.FAKTUROMANIA_REGULAMIN_PAGE_URL}>Regulaminie Serwisu</Link>.
            </li>
            <li>
              Polityka cookies ma charakter informacyjny i nie nakłada na Użytkowników obowiązków.
            </li>
          </ol>
        </StatuteBlock>

        <StatuteSectionHeader ordinal={2} sectionName="Pliki cookies i podobne technologie"/>
        <StatuteBlock>
          <ol>
            <li>
              Cookies to niewielkie pliki tekstowe zapisywane przez przeglądarkę internetową w urządzeniu Użytkownika. Zawierają zazwyczaj nazwę
              domeny, z której pochodzą, czas przechowywania oraz przypisaną wartość, np. unikalny identyfikator.
            </li>
            <li>
              Serwis korzysta także z podobnych technologii, w szczególności z pamięci lokalnej przeglądarki (local storage) oraz ze skryptów
              przesyłających do serwerów Administratora lub dostawców zewnętrznych informacje o korzystaniu z Serwisu. Postanowienia Polityki
              cookies dotyczące cookies stosuje się do tych technologii odpowiednio.
            </li>
            <li>
              Cookies własne zapisuje Administrator w domenie fakturomania.pl, a cookies podmiotów trzecich – dostawcy narzędzi zewnętrznych.
              Cookies sesyjne są usuwane po zamknięciu przeglądarki, a cookies trwałe – po upływie okresu wskazanego w § 4 albo wcześniej,
              jeżeli Użytkownik je usunie.
            </li>
            <li>
              Identyfikatory zapisywane w cookies mogą stanowić dane osobowe, w szczególności gdy zostaną powiązane z Kontem lub z innymi
              informacjami o Użytkowniku.
            </li>
          </ol>
        </StatuteBlock>

        <StatuteSectionHeader ordinal={3} sectionName="Zgoda i zarządzanie cookies"/>
        <StatuteBlock>
          <ol>
            <li>
              Cookies niezbędne oraz niezbędne dane w pamięci lokalnej przeglądarki (§ 4 ust. 1 pkt 1 i ust. 5) są stosowane bez zgody
              Użytkownika, ponieważ są konieczne do świadczenia usługi, z której Użytkownik korzysta, w tym do zapewnienia jej bezpieczeństwa
              (art. 399 ustawy z dnia 12 lipca 2024 r. – Prawo komunikacji elektronicznej).
            </li>
            <li>
              Cookies analityczne i marketingowe oraz dane w pamięci lokalnej z tych kategorii (§ 4 ust. 1 pkt 2 i 3 oraz ust. 5) są zapisywane
              i odczytywane wyłącznie po wyrażeniu przez Użytkownika zgody w banerze cookies wyświetlanym przy pierwszej wizycie w Serwisie.
              Do czasu wyrażenia zgody narzędzia analityczne i marketingowe nie są uruchamiane.
            </li>
            <li>
              Zgoda jest dobrowolna. Użytkownik może zaakceptować wszystkie kategorie cookies, wybrać poszczególne kategorie albo poprzestać
              na cookies niezbędnych. Odmowa zgody nie ogranicza możliwości korzystania z Serwisu.
            </li>
            <li>
              Użytkownik może w każdej chwili zmienić dokonany wybór lub wycofać zgodę, korzystając z odnośnika „Preferencje plików cookies”
              dostępnego na stronach Serwisu. Wycofanie zgody nie wpływa na zgodność z prawem przetwarzania, którego dokonano na podstawie
              zgody przed jej wycofaniem.
            </li>
            <li>
              Po wycofaniu zgody Administrator usuwa cookies własne i dane w pamięci lokalnej danej kategorii. Cookies zapisane w domenach
              podmiotów trzecich, np. google.com, Użytkownik może usunąć w ustawieniach przeglądarki.
            </li>
            <li>
              Informację o dokonanym wyborze Administrator przechowuje w pliku cookie przez 180 dni. Po tym okresie, a także w razie zmiany
              celów lub kategorii cookies stosowanych na podstawie zgody, baner wyświetla się ponownie.
            </li>
            <li>
              Niezależnie od banera Użytkownik może blokować lub usuwać cookies w ustawieniach przeglądarki. Zablokowanie cookies niezbędnych
              może uniemożliwić zalogowanie się do aplikacji lub korzystanie z czatu.
            </li>
          </ol>
        </StatuteBlock>

        <StatuteSectionHeader ordinal={4} sectionName="Kategorie cookies i podobnych technologii"/>
        <StatuteBlock>
          <ol>
            <li>
              Administrator stosuje cookies i podobne technologie w następujących kategoriach:
              <ol className="parenthesis-numbered">
                <li>
                  <strong>niezbędne</strong> – służą do prawidłowego działania Serwisu, utrzymania sesji po zalogowaniu, zapewnienia
                  bezpieczeństwa, zapamiętania wyboru dokonanego w banerze cookies oraz do obsługi czatu i centrum pomocy uruchomionych
                  przez Użytkownika; są stosowane bez zgody;
                </li>
                <li>
                  <strong>analityczne</strong> – służą do tworzenia statystyk korzystania z Serwisu oraz do ustalania, z jakich źródeł,
                  np. kampanii reklamowych, Użytkownicy trafiają do Serwisu; są stosowane wyłącznie za zgodą;
                </li>
                <li>
                  <strong>marketingowe</strong> – służą do pomiaru skuteczności reklam Administratora oraz do wyświetlania reklam
                  Administratora osobom, które odwiedziły Serwis (remarketing); są stosowane wyłącznie za zgodą.
                </li>
              </ol>
            </li>
            <li>
              Cookies i podobne technologie zapisują w Serwisie Administrator oraz dostawcy narzędzi zewnętrznych, w szczególności Google Ireland
              Limited (Google Analytics, Google Ads) oraz Freshworks Inc. (czat i centrum pomocy).
            </li>
            <li>
              Jeżeli Użytkownik wyraził zgodę na cookies analityczne, przy rejestracji i logowaniu identyfikator wizyty nadawany przez
              Administratora oraz identyfikator Google Analytics są przypisywane do Konta. Pozwala to Administratorowi ustalić, z jakiego
              źródła Użytkownik trafił do Serwisu, i ocenić skuteczność działań marketingowych. Informacje o wizytach powiązane z tym
              identyfikatorem są przesyłane do systemu analitycznego Administratora.
            </li>
            <li>
              Okres przechowywania cookies wynosi, zależnie od pliku, od czasu trwania sesji przeglądarki do 2 lat.
            </li>
            <li>
              <strong>Pamięć lokalna przeglądarki.</strong> Oprócz cookies Serwis zapisuje dane w pamięci lokalnej przeglądarki (localStorage).
              W odróżnieniu od cookies dane te nie są automatycznie przesyłane do serwera i nie mają terminu ważności – pozostają w urządzeniu
              do czasu ich usunięcia przez Serwis albo przez Użytkownika, np. przez wyczyszczenie danych witryny w ustawieniach przeglądarki.
              W pamięci lokalnej aplikacja przechowuje stan sesji i ustawienia, a czat – identyfikator rozmowy (dane niezbędne). Google Ads
              zapisuje tam informację o kliknięciu w reklamę (dane marketingowe, zapisywane wyłącznie za zgodą).
            </li>
            <li>
              Aktualny wykaz cookies i danych zapisywanych w pamięci lokalnej, wraz z ich nazwami, dostawcami, celami i okresami przechowywania,
              jest dostępny w ustawieniach banera cookies. Baner wyświetla się przy pierwszej wizycie w Serwisie, a później jest dostępny
              w każdej chwili przez odnośnik „Preferencje plików cookies”.
            </li>
          </ol>
        </StatuteBlock>

        <StatuteSectionHeader ordinal={5} sectionName="Pozostałe usługi zewnętrzne"/>
        <StatuteBlock>
          <ol>
            <li>
              <strong>Logowanie przez Google.</strong> Na stronach logowania i rejestracji aplikacji ładowany jest skrypt Google umożliwiający
              rejestrację i logowanie za pomocą konta Google. Po wybraniu tej opcji Google uwierzytelnia Użytkownika z wykorzystaniem własnych
              cookies w domenie google.com i przekazuje Administratorowi adres e-mail oraz podstawowe dane profilu. Zasady przetwarzania danych
              przez Google określa polityka prywatności Google.
            </li>
            <li>
              <strong>Czcionki.</strong> Serwis pobiera czcionki z serwerów Google Fonts, co wiąże się z przekazaniem Google adresu IP urządzenia
              Użytkownika. Usługa Google Fonts nie zapisuje cookies.
            </li>
            <li>
              <strong>Media społecznościowe.</strong> Serwis zawiera odnośniki do profilu Administratora w serwisie Facebook. Odnośniki nie
              zapisują cookies i nie przekazują danych dostawcy serwisu społecznościowego do momentu ich kliknięcia. Po przejściu do serwisu
              społecznościowego obowiązują zasady określone przez jego dostawcę.
            </li>
            <li>
              <strong>Czat.</strong> Okno czatu (Freshchat) jest ładowane po kliknięciu ikony czatu przez Użytkownika. Rozmowy w czacie są
              przetwarzane na zasadach określonych w § 10 Regulaminu.
            </li>
          </ol>
        </StatuteBlock>

        <StatuteSectionHeader ordinal={6} sectionName="Podstawy prawne, odbiorcy i okres przetwarzania danych"/>
        <StatuteBlock>
          <ol>
            <li>
              Dane zbierane za pomocą cookies niezbędnych Administrator przetwarza w celu świadczenia usług w Serwisie i zapewnienia ich
              bezpieczeństwa – na podstawie art. 6 ust. 1 lit. b RODO, gdy jest to niezbędne do wykonania umowy z Użytkownikiem, a w pozostałym
              zakresie na podstawie art. 6 ust. 1 lit. f RODO, czyli prawnie uzasadnionego interesu Administratora polegającego na zapewnieniu
              działania i bezpieczeństwa Serwisu.
            </li>
            <li>
              Dane zbierane za pomocą cookies analitycznych i marketingowych, w tym informacje o źródle wejścia przypisane do Konta zgodnie
              z § 4 ust. 3, Administrator przetwarza na podstawie zgody (art. 6 ust. 1 lit. a RODO) w celach statystycznych, w celu pomiaru
              skuteczności działań marketingowych oraz prowadzenia działań marketingowych.
            </li>
            <li>
              Odbiorcami danych mogą być: Google Ireland Limited, Gordon House, Barrow Street, Dublin 4, Irlandia – w zakresie Google Analytics,
              Google Ads, logowania przez Google i Google Fonts; Freshworks Inc. z siedzibą w USA – w zakresie czatu i centrum pomocy, wraz z jej
              podwykonawcami, w tym Cloudflare, Inc.; dostawca hostingu Serwisu – OVH.
            </li>
            <li>
              Dane mogą być przekazywane do USA: przez Google – na podstawie decyzji Komisji Europejskiej stwierdzającej odpowiedni stopień
              ochrony w ramach EU-US Data Privacy Framework (art. 45 RODO) oraz standardowych klauzul umownych, a przez Freshworks – na podstawie
              standardowych klauzul umownych przyjętych przez Komisję Europejską (art. 46 ust. 2 lit. c RODO). Kopię stosowanych zabezpieczeń
              można uzyskać, kontaktując się z Administratorem.
            </li>
            <li>
              Cookies przechowywane są przez okresy wskazane w § 4 ust. 4 i w wykazie, o którym mowa w § 4 ust. 6, a dane w pamięci lokalnej –
              do czasu ich usunięcia (§ 4 ust. 5). Dane w Google Analytics są przechowywane przez 14 miesięcy. Informacje o źródle wejścia
              przypisane do Konta są przetwarzane do czasu wycofania zgody, nie dłużej jednak niż do usunięcia Konta. Dane przetwarzane na
              podstawie prawnie uzasadnionego interesu są przetwarzane do czasu wniesienia skutecznego sprzeciwu.
            </li>
            <li>
              Użytkownikowi przysługuje prawo dostępu do danych, ich sprostowania, usunięcia, ograniczenia przetwarzania i przenoszenia, prawo
              sprzeciwu wobec przetwarzania opartego na prawnie uzasadnionym interesie, prawo wycofania zgody w dowolnym momencie oraz prawo
              wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych (ul. Stawki 2, 00-193 Warszawa).
            </li>
            <li>
              Remarketing w Google Ads wiąże się z profilowaniem w celu dopasowania wyświetlanych reklam. Administrator nie podejmuje wobec
              Użytkowników decyzji opartych wyłącznie na zautomatyzowanym przetwarzaniu, które wywoływałyby wobec nich skutki prawne lub
              w podobny sposób istotnie na nich wpływały (art. 22 RODO).
            </li>
            <li>
              Wyrażenie zgody na cookies analityczne i marketingowe jest dobrowolne. Zablokowanie cookies niezbędnych może uniemożliwić
              korzystanie z niektórych funkcji Serwisu.
            </li>
            <li>
              Informacje o przetwarzaniu danych osobowych Użytkowników posiadających Konto zawiera ponadto § 10 Regulaminu.
            </li>
          </ol>
        </StatuteBlock>

        <StatuteSectionHeader ordinal={7} sectionName="Zmiany Polityki cookies"/>
        <StatuteBlock>
          <ol>
            <li>
              Administrator aktualizuje Politykę cookies w razie zmiany stosowanych narzędzi lub przepisów. Aktualna wersja jest dostępna pod
              adresem <a href="https://fakturomania.pl/cookies" target="_blank">https://fakturomania.pl/cookies</a>.
            </li>
            <li>
              Jeżeli zmiana dotyczy celów lub kategorii cookies stosowanych na podstawie zgody, Administrator ponownie prosi Użytkownika o zgodę
              za pośrednictwem banera cookies.
            </li>
          </ol>
        </StatuteBlock>

      </StatuteBlockWrapper>
    </div>
  )
};

export default CookieStatuteBlock



// WEBPACK FOOTER //
// ./src/layouts/statute-block/cookies-statute-block.tsx